import React, { Component } from "react";
import ListItem from "@material-ui/core/ListItem";
import CreateIcon from "@material-ui/icons/Create";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import SwapIcon from "@material-ui/icons/SwapHoriz";
import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/CheckCircle";

class PouleSpot extends Component {
  render() {
    const { team } = this.props;

    let style = {
      display: "flex",
      alignItems: "center",
    };
    if (team.empty && !team.status) {
      style = {
        color: "gray",
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
      };
    }

    return this.props.teamsLoaded && this.props.resultSpotsLoaded ? (
      <ListItem
        button
        aria-haspopup="true"
        aria-controls="lock-menu"
        aria-label="Team"
        onClick={(e) => {
          this.props.handleClickPouleSpot(e, team);
        }}
        style={{ height: 30, paddingLeft: 10, paddingRight: 10 }}
        disabled={
          (team.belongsToBracket && !team.bracketRound === 2) ||
          this.props.resultsPage
            ? true
            : this.props.bracket
            ? this.props.bracket.size !== this.props.poule.bracketRound ||
              (this.props.bracket.subBracketTo !== null &&
                this.props.bracket.subBracketTo !== undefined)
            : false
        }
      >
        <div
          style={{
            marginRight:
              (!team.empty && team.fase !== undefined && !team.status) ||
              team.present
                ? 25
                : 0,
          }}
        >
          <Typography variant="body2" style={style}>
            <span
              style={{
                color: team.empty && !team.status ? "#ad0000" : "",
                fontStyle: team.status ? "italic" : "normal",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width:
                  (!team.empty && team.fase !== undefined && !team.status) ||
                  team.present ||
                  team.empty
                    ? 180
                    : 200,
              }}
            >
              {team.gamertag || team.name}
            </span>
          </Typography>
        </div>
        <div style={{ flex: "1 1 10%" }} />
        {!team.belongsToBracket &&
          !this.props.resultsPage &&
          (team.empty && !team.status ? (
            <CreateIcon
              style={{
                height: 15,
                width: 15,
                float: "right",
                color: "gray",
              }}
            />
          ) : (
            team.fase !== undefined &&
            !this.props.resultsPage && (
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  style={{ width: 30, height: 30 }}
                  onClick={(e) => {
                    this.props.toggleResultSpotType(e, team.fase, team.rank);
                  }}
                >
                  <SwapIcon
                    style={{ height: 20, position: "absolute", top: 5 }}
                  />
                </IconButton>
              </ListItemSecondaryAction>
            )
          ))}
        {team.present && this.props.poule.fase === 0 && (
          <ListItemSecondaryAction>
            <IconButton edge="end" disabled style={{ width: 30, height: 30 }}>
              <CheckIcon
                style={{
                  height: 17,
                  position: "absolute",
                  top: 7,
                  color: "green",
                }}
              />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
    ) : (
      <div style={{ height: 30 }} />
    );
  }
}

export default PouleSpot;
